import getConfig from 'next/config';
import { getCookie } from '../../../utils/cookieUtils';
import { LOCAL_STORAGE_GUIDE_KEYS } from '../../S/cleartax-itr-filing-guide/constants';
import {
  INCOME_TAX,
  INCOME_TAX_B2B,
  PERSONAL_FINANCE,
} from './breadcrumb-category-data';
import { ISOCIAL_MEDIA } from './types';

const { publicRuntimeConfig } = getConfig();
export const pageCategoryName = {
  default: 'income-tax',
  personalFinance: 'personal-finance',
  b2b: 'b2b',
};
export const TOPICS: Record<
  string,
  Record<string, Array<{ title: string; permalink: string }>>
> = {
  'cleartax.in': {
    [pageCategoryName.default]: INCOME_TAX,
    [pageCategoryName.personalFinance]: PERSONAL_FINANCE,
    [pageCategoryName.b2b]: INCOME_TAX_B2B,
  },
  'clear.tech': {},
};

export const getSocialMediaData = ({
  linkedin,
  facebook,
  twitter,
  whatsapp,
}: ISOCIAL_MEDIA): Array<{
  name: string;
  link: string;
  icon: string;
  action?: string;
}> => {
  const data = [
    {
      name: 'linkedIn',
      link: linkedin || '',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1614458073_linkedin.svg',
    },
    {
      name: 'facebook',
      link: facebook || '',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1614458096_facebook.svg',
    },
    {
      name: 'twitter',
      link: twitter || '',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1614458047_twitter.svg',
    },
    {
      name: 'whatsapp',
      link: whatsapp || '',
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1614457687_whatsapp.svg',
      action: 'share/whatsapp/share',
    },
  ];
  return data;
};

export const getFileItrLink = () => {
  const defaultURLs = {
    filingUrl: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing`,
    logoUrl: `${publicRuntimeConfig.CLEARTAX_DOMAIN}`,
  };

  if (typeof window === 'undefined' || typeof document === 'undefined')
    return defaultURLs;

  const isLoggedInUser = getCookie('isloggedin');
  const { guideEntityId, guideEntityIndex, guideFinancialYear } =
    LOCAL_STORAGE_GUIDE_KEYS;

  const entityId = window.localStorage.getItem(guideEntityId);
  const entityIndex = window.localStorage.getItem(guideEntityIndex);
  const financialYear = window.localStorage.getItem(guideFinancialYear);
  const FILING_URL = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/${financialYear}/${entityIndex}/${entityId}`;

  if (!entityId || !entityIndex == null || !financialYear || !isLoggedInUser)
    return defaultURLs;

  return {
    filingUrl: FILING_URL,
    logoUrl: FILING_URL,
  };
};

export const LOGOS = {
  clear: {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683802364_clearlogolight.svg',
    link: () => 'https://www.clear.in/',
    height: '20px',
    width: '64px',
  },
  cleartax: {
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d9f36ac3-77a9-40c6-94fc-20c2e3855457.svg',
    link: () => 'https://cleartax.in/',
    height: '27px',
    width: '120px',
  },
  clearFromCleartax: {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1665038118_clearlogo1.svg',
    link: () => 'https://cleartax.in/',
  },
  clearTechDark: {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675151654_group1000002542.png',
    link: () => 'https://www.clear.tech/',
  },
  clearTechLight: {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1682581587_cleartechlight.png',
    link: () => 'https://www.clear.tech/',
  },
  itrGuide: {
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d9f36ac3-77a9-40c6-94fc-20c2e3855457.svg',
    link: getFileItrLink,
    height: '27px',
    width: '120px',
  },
};

export const CMS_PAGINATION_LIMIT = publicRuntimeConfig.CMS_PAGINATION_LIMIT;
export const CMS_PAGINATION_CONCURRANCY =
  publicRuntimeConfig.CMS_PAGINATION_CONCURRANCY;

//Remove this post season 2024
export const INLINE_CTA = `<style>

 .banner-link{
        text-decoration: none;
        color: black;
      }
      .inline-button {
      text-decoration: none;
    font-family: Gilroy;
    font-weight: 600;
    line-height: 132%;
    background: #1572ed;
    border-radius: 8px;
    white-space: nowrap;
    padding: 14px 24px;
    font-size: 20px;
    color: #ffffff;
    margin-right: 31px;
      }
      .inline-button:hover {
        background: #0f5bb5;
        transform: scale(1.05);
        transition: background 0.3s ease, transform 0.3s ease;
      }
      .inline-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #d0e4fe;
      }
      .inline-heading {
        font-family: Gilroy;
        font-weight: 700;
        font-size: 25px;
        color: black;
      }
      .subinline-heading {
        font-family: Gilroy;
        font-weight: 500;
        color: black;
        font-size: 16px;
      }
      .inline-left {
        padding-left: 31px;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      @media screen and (min-width: 1024px) and (max-width: 1439px) {
       .inline-container {
          display: flex; 
      }
      .inline-heading {
        font-family: Gilroy;
        font-weight: 700;
        font-size: 20px;
      }
      .inline-button {
       text-decoration: none;
       font-family: Gilroy;
       font-weight: 600;
       line-height: 132%;
       background: #1572ed;
       border-radius: 8px;
       padding: 10px 13px;
       white-space: nowrap;
       font-size: 16px;
       color: #ffffff;
       margin-right: 31px;
    }
}
      @media screen and (min-width: 768px) and (max-width: 1023px) {
        .inline-container {
          display: block;
        }
        .inline-heading {
          font-size: 25px;
          margin-left: 10px;
          color: black;
        }
        .subinline-heading {
          font-size: 18px;
          margin-left: 10px;
          color: black;
        }
        .inline-button {
          font-size: 20px;
          margin: 0px;
          text-align: center;
        }
        .inline-left {
          padding-left: 18px;
          padding-right: 18px;
          padding-bottom: 12px;
          padding-top: 28px;
        }
        .inline-button-div {
          padding-bottom: 28px;
          padding-left: 24px;
          padding-right: 24px;
          margin-top: 20px;
        }
      }
       @media screen and (max-width: 767px) {
        .inline-container {
          display: block;
        }
        .inline-heading {
          font-size: 24px;
          line-height: 30px
          color: black;
        }
        .subinline-heading {
          font-size: 14px;
          line-height: 35px;
          color: black;
        }
        .inline-button {
          font-size: 13px;
          margin: 0px;
          text-align: center;
          width: 91%;
          white-space: nowrap;
        }
        .inline-left {
          padding-left: 24px;
          padding-right: 24px;
          padding-bottom: 16px;
          padding-top: 28px;
        }
        .inline-button-div {
          padding-bottom: 28px;
          padding-left: 24px;
          padding-right: 24px;
        }
       }
</style>
<div class="inline-outer-container">
      <a
        href="https://cleartax.in/s/pricing?utm_ref=itr_2025_organic_in-lineCTA_last"
        target="_blank"
        class="banner-link"
      >
        <div class="inline-container">
          <div class="inline-left">
            <div class="inline-heading">Maximize Your Refund, Minimize The Effort.</div>
            <div class="subinline-heading">Expert tax help, just a click away.</div>
          </div>
          <div class="inline-button-div">
            <div class="inline-button">Hire An Expert</div>
          </div>
        </div>
      </a>
    </div>
`;

export const INLINE_CTA_CHECKLIST = [
  8, 114, 40, 127, 301, 297, 314, 33, 37, 311, 36, 98, 122, 72, 73, 87, 86, 305,
  105, 41, 99, 101, 103, 38, 39, 42, 45, 92, 304, 303, 302, 89, 298, 312, 315,
  316, 216, 311, 21, 90, 22, 74, 66, 46, 75, 76, 299, 300, 104, 313, 44, 296,
  192, 62, 129, 193, 296, 196, 195, 194,
];
